import { Component, Input, OnInit } from '@angular/core';
import { EmptyPlaceholderType } from './empty-placeholder.enum';

@Component({
    selector: 'app-empty-placeholder',
    templateUrl: './empty-placeholder.component.html',
    styleUrl: './empty-placeholder.component.scss',
})
export class EmptyVideoPlaceholderComponent implements OnInit {
    @Input() description = '';
    @Input() type: EmptyPlaceholderType | null = null;

    icon = '';

    ngOnInit(): void {
        this.initIcon();
    }

    protected initIcon(): void {
        if (!this.type) {
            return;
        }

        switch (this.type) {
            case EmptyPlaceholderType.EmptyVideoPlaceholder:
                this.icon = 'bg-empty-video-placeholder';

                break;
            case EmptyPlaceholderType.EmptyFilePlaceholder:
                this.icon = 'bg-empty-file-placeholder';

                break;
        }
    }
}
